import background1 from "@assets/images/background1.png";
import logoBanner from "@assets/images/logoBanner.png";
import loveGesture from "@assets/images/loveGesture.png";
import mapImg from "@assets/images/map.png";
import walletImg from "@assets/images/wallet.png";
import { Card } from "@shared/components/Card";
import { PrimaryButton } from "@shared/components/PrimaryButton";
import { Section } from "@shared/components/Section";
import { Link } from "react-router-dom";

const FEATURES = [
  {
    title: "Real-time connections",
    subtitle: "Only match with people at your venue",
    image: mapImg,
    imageAlt: "Map icon",
  },
  {
    title: "No subscriptions",
    subtitle: "ten hours free at the event; optional unlock after",
    image: walletImg,
    imageAlt: "Wallet icon",
  },
  {
    title: "Instant matches",
    subtitle: "Skip the small talk, meet your match there and then",
    image: loveGesture,
    imageAlt: "Love gesture icon",
  },
] as const;

export function LandingPage() {
  return (
    <main className="flex flex-col min-h-screen bg-[var(--color-background)]">
      <section
        className="w-full min-h-[50vh] flex flex-col items-center justify-center section-padding bg-cover bg-center"
        style={{ backgroundImage: `url(${background1})` }}
      >
        <img
          src={logoBanner}
          alt="Fitties"
          className="max-logo-banner-width w-full h-[120px] object-contain object-center mb-4"
        />
        <PrimaryButton to="/auth" size="default">
          Go to App
        </PrimaryButton>
      </section>

      <Section className="bg-[var(--color-background)] section-gap-tight">
        <h2 className="font-mono font-extrabold text-center text-[length:var(--font-size-headline-medium)]">
          How It Works
        </h2>
        <div className="flex justify-center">
          <Card constrainWidth>
            <p className="font-mono font-semibold text-[length:var(--font-size-body-large)] text-start">
              Fitties turns any venue or event into an in-person dating app.
              <br />
              <br />
              Scan the venue QR, sign in, and use the app free for ten hours from entry. Pay only if you want full
              access to continue after that window for this event.
            </p>
          </Card>
        </div>
      </Section>

      <Section className="bg-[var(--color-background)]">
        <h2 className="font-mono font-extrabold text-center text-[length:var(--font-size-headline-medium)]">
          Why Use Fitties?
        </h2>
        <div className="flex flex-col section-gap items-center">
          {FEATURES.map(({ title, subtitle, image, imageAlt }) => (
            <div key={title} className="flex flex-col items-center text-center">
              <img
                src={image}
                alt={imageAlt}
                className="w-[120px] h-[120px] rounded-feature-icon object-cover flex-shrink-0"
              />
              <p className="mt-4 font-mono font-bold text-[length:var(--font-size-body-large)]">{title}</p>
              <p className="text-[length:var(--font-size-body-medium)] text-lavender-700">{subtitle}</p>
            </div>
          ))}
        </div>
      </Section>

      <section className="w-full min-h-[300px] flex flex-col items-center justify-center section-padding relative">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${background1})` }} />
        <div className="absolute inset-0 bg-secondary/85" />
        <div className="relative z-10 flex flex-col items-center justify-center w-full">
          <h2 className="font-mono font-semibold text-[length:var(--font-size-headline-large)] text-secondary-foreground text-center">
            Start Swiping Tonight!
          </h2>
          <PrimaryButton to="/auth" size="large" className="mt-6">
            Go to App
          </PrimaryButton>
          <p className="mt-10 text-center text-[length:var(--font-size-body-medium)] text-secondary-foreground max-w-[90%] opacity-90">
            Event entry includes ten hours free. Paid unlock removes expiry after that. All purchases are final; no
            refunds once unlock is granted.
          </p>
          <div className="mt-12 text-center flex flex-wrap justify-center gap-x-4 gap-y-1 text-[length:var(--font-size-body-medium)]">
            <Link to="/privacy" className="font-mono text-secondary-foreground hover:underline">
              Privacy Policy
            </Link>
            <span className="text-secondary-foreground/80">–</span>
            <Link to="/terms" className="font-mono text-secondary-foreground hover:underline">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
